import React from "react";

import Region from "./region";
import Streets from "./streets";

const Regions = ({ regions }) => {
	return (
		<div className="step region-step">
			{regions.map((regionObj) => {
				if (regionObj.regionId) {
					return (
						<Region
							region={regionObj}
							key={regionObj.regionId || "noRegionId"}
						/>
					);
				} else {
					return null;
				}
			})}
			{regions.map((regionObj) => {
				if (regionObj.regionId) {
					return null;
				} else {
					return (
						<Streets
							streets={regionObj.streets}
							withoutRegion
							key={regionObj.regionId || "noRegionId"}
						/>
					);
				}
			})}
		</div>
	);
};

export default Regions;
